// extracted by mini-css-extract-plugin
export const carousel_card = "HomeCarousel-module--carousel_card--2Rm6P";
export const carousel_image = "HomeCarousel-module--carousel_image--3LVtx";
export const carousel_content = "HomeCarousel-module--carousel_content--g-ACB";
export const carousel_title = "HomeCarousel-module--carousel_title--5lt-x";